import { Injectable, InjectionToken, Signal, inject, signal, type WritableSignal } from '@angular/core';

import type { DataGridState } from './contracts/data-grid-state.interface';
import type { GridStatePersistence } from './contracts/grid-state-persistence.interface';

const DEFAULT_DATA_GRID_STATE: DataGridState = {
  groupByFields: [],
  hiddenColumns: [],
  columnOrder: [],
  discriminatorColumnOrder: {},
  columnWidths: {}
};

/** In-memory grid state persistence for Storybook and hosts without persistence needs. */
@Injectable({ providedIn: 'root' })
export class InMemoryGridStatePersistence implements GridStatePersistence {
  private readonly readySignal: WritableSignal<boolean> = signal(true);
  private readonly stateSignal: WritableSignal<DataGridState> = signal(DEFAULT_DATA_GRID_STATE);

  public readonly ready: Signal<boolean> = this.readySignal.asReadonly();
  public readonly state: Signal<DataGridState> = this.stateSignal.asReadonly();

  public save(state: DataGridState): void {
    this.stateSignal.set(state);
  }
}

/**
 * Host-provided persistence for grid UI state.
 * Defaults to {@link InMemoryGridStatePersistence} when no host provider is registered.
 */
export const GRID_STATE_PERSISTENCE: InjectionToken<GridStatePersistence> =
  new InjectionToken<GridStatePersistence>('GRID_STATE_PERSISTENCE', {
    providedIn: 'root',
    factory: (): GridStatePersistence => inject(InMemoryGridStatePersistence)
  });
